import { CompassTool } from "@phosphor-icons/react";
import { InfoHint } from "./InfoHint";

const levelCfg = {
  success: { c: "#00e676", t: "Стабильный режим" },
  warning: { c: "#ffea00", t: "Режим плавает" },
  alert: { c: "#ff3b30", t: "Хаотичный режим" },
};

export default function CircadianCard({ circ }) {
  if (!circ) return null;
  const cfg = levelCfg[circ.level];
  const hrvDiff = circ.hrv_stable != null && circ.hrv_erratic != null
    ? Math.round((circ.hrv_stable - circ.hrv_erratic) * 10) / 10 : null;
  const stats = [
    ["Разброс отбоя", `±${circ.bed_sd_min} мин`, "circ-bed-sd"],
    ["Разброс подъёма", `±${circ.wake_sd_min} мин`, "circ-wake-sd"],
    ["Социальный джетлаг", circ.social_jetlag_min != null ? `${circ.social_jetlag_min > 0 ? "+" : ""}${circ.social_jetlag_min} мин` : "—", "circ-jetlag"],
  ];
  return (
    <div className="glass-card p-5" data-testid="circadian-card">
      <div className="flex items-center gap-2 mb-1">
        <CompassTool size={18} weight="fill" style={{ color: cfg.c }} />
        <h3 className="text-sm font-semibold">Циркадный ритм · <span style={{ color: cfg.c }}>{cfg.t}</span><InfoHint text="Циркадный ритм — стабильность времени отбоя и подъёма изо дня в день. Чем стабильнее режим, тем качественнее сон и выше HRV." /></h3>
      </div>
      <p className="text-xs text-muted-foreground mb-4">
        {circ.social_jetlag_min != null && Math.abs(circ.social_jetlag_min) >= 30 && <>В выходные ваш сон сдвигается на {Math.abs(circ.social_jetlag_min)} мин — это «социальный джетлаг», организм каждый понедельник живёт как после перелёта. </>}
        {hrvDiff != null && hrvDiff > 1 && <>В дни со стабильным отбоем ваша HRV в среднем на <span className="text-[#00e676] font-semibold num">{hrvDiff} мс выше</span> ({circ.hrv_stable} против {circ.hrv_erratic} мс).</>}
        {hrvDiff != null && hrvDiff <= 1 && <>Заметной разницы HRV между стабильными и «плавающими» днями пока не видно.</>}
      </p>
      <div className="grid grid-cols-3 gap-2">
        {stats.map(([l, v, tid]) => (
          <div key={tid} className="rounded-md bg-secondary/40 p-3 text-center" data-testid={tid}>
            <div className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">{l}</div>
            <div className="num font-semibold text-sm">{v}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
